import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-eclipse flex items-center justify-center">
        <div className="font-mono text-xs tracking-widest text-accent uppercase animate-pulse">
          Cargando…
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/admin" replace />;
  return children;
}
